export const INCREMENT_ITEM_COUNT = "INCREMENT_ITEM_COUNT";
export const DECREMENT_ITEM_COUNT = "DECREMENT_ITEM_COUNT";
export const REMOVE_ITEM_COUNT = "REMOVE_ITEM_COUNT";
export const REFRESH_STORE = "REFRESH_STORE";
